module.exports = "label {\r\n    width: 100px\r\n}"